import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import { useEffect } from "react";
import "./Navbar.css";
import {
  FiSearch,
  FiUser,
  FiShoppingBag,
  FiMenu,
  FiX,
} from "react-icons/fi";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { cartItems } = useCart();
  const navigate = useNavigate();
const [search, setSearch] = useState("");
const [showSearch, setShowSearch] = useState(false);
const [user, setUser] = useState(null);
const [showMenu, setShowMenu] = useState(false);

useEffect(() => {
  const storedUser = localStorage.getItem("user");

  if (storedUser) {
    setUser(JSON.parse(storedUser));
  }
}, []);

const totalItems = cartItems.reduce(
  (total, item) => total + item.quantity,
  0
);

  return (
    <>
      <nav className="navbar-section">
       <div className="nav-container">

          <div className="mobile-menu">
            <FiMenu onClick={() => setMenuOpen(true)} />
          </div>

          <div className="nav-left">
            <a href="/shop">SHOP</a>
            <a
  href="/#collections"
  onClick={(e) => {
    e.preventDefault();

    if (window.location.pathname === "/") {
      document
        .getElementById("collections")
        ?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#collections";
    }
  }}
>
  COLLECTIONS
</a>
            <a href="/about">ABOUT</a>
            <a href="/">SCENTS</a>
          </div>

          <div className="nav-logo">
            <a href="/">SAH?</a>
          </div>

          <div className="nav-right">
           <div className="search-box">

  {showSearch && (
    <input
      type="text"
      placeholder="Search products..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter" && search.trim()) {
          navigate(`/shop?search=${encodeURIComponent(search)}`);
          setShowSearch(false);
        }
      }}
    />
  )}

  <FiSearch
    className="nav-icon"
    onClick={() => {
      if (showSearch && search.trim()) {
        navigate(`/shop?search=${encodeURIComponent(search)}`);
        setShowSearch(false);
      } else {
        setShowSearch(!showSearch);
      }
    }}
  />

</div>
  {user ? (
  <div className="user-menu">

    {/* Icon click = Profile */}
    <Link to="/profile">
      <FiUser className="nav-icon" />
    </Link>

    {/* Name click = Dropdown */}
    <span
      onClick={() => setShowMenu(!showMenu)}
      className="user-name"
    >
      Hi, {user.name || user.username} 
    </span>

    {showMenu && (
      <div className="dropdown-menu">
        <Link to="/profile">
          My Profile
        </Link>

        <Link to="/orders">
          My Orders
        </Link>

        <button
          onClick={() => {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            window.location.reload();
          }}
        >
          Logout
        </button>
      </div>
    )}

  </div>
) : (
  <Link to="/Userlogin">
    <FiUser className="nav-icon" />
  </Link>
)}
           <Link to="/cart" className="cart-icon-wrapper">
  <FiShoppingBag className="nav-icon" />

  {totalItems > 0 && (
    <span className="cart-badge">
      {totalItems}
    </span>
  )}
</Link>
          </div>

        </div>
      </nav>

      <div className={`sidebar ${menuOpen ? "show" : ""}`}>
        <div className="sidebar-top">
          <FiX
            className="close-icon"
            onClick={() => setMenuOpen(false)}
          />
        </div>

        <a href="/shop" onClick={() => setMenuOpen(false)}>
          SHOP
        </a>

        <a href="/" onClick={() => setMenuOpen(false)}>
          COLLECTIONS
        </a>

        <a href="/about" onClick={() => setMenuOpen(false)}>
          ABOUT
        </a>

        <a href="/" onClick={() => setMenuOpen(false)}>
          FRAGRANCES
        </a>
      </div>

      {menuOpen && (
        <div
          className="overlay"
          onClick={() => setMenuOpen(false)}
        ></div>
      )}
    </>
  );
}

export default Navbar;